import { List } from 'immutable';
import { DesignTemplates } from 'records/DesignTemplate';
import BaseList from 'records/BaseList';

import {
  SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
  SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
  SEASONAL_FLOW_DESIGN_TEMPLATES_RESET_STATE,
} from 'actions/seasonalFlowDesignTemplates';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignTemplates(action.data),
    });
  },
  [SEASONAL_FLOW_DESIGN_TEMPLATES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function seasonalFlowDesignTemplates(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
